import { useContext } from 'react';

import {
  OrchestratorAutoflowContext,
  OrchestratorAutoflowContextValue,
} from './OrchestratorAutoflowContextValue';

export const useOrchestratorAutoflowContext =
  (): OrchestratorAutoflowContextValue => {
    return useContext(OrchestratorAutoflowContext);
  };
